export default (value) => value[value.length - 1] === ' ';
